export default __webpack_public_path__ + "static/media/waving.2a60fd73.glb";